import React from 'react';
import DocumentTitle from 'react-document-title';

const PageTitle = (props) => {
  return (
    <DocumentTitle title={`Epic Africa ${props.title ? `| ${props.title}`: ''}`}></DocumentTitle>
  );
};

export default PageTitle;


// WEBPACK FOOTER //
// ./src/shared/PageTitle.js